<template>
  <div>
    <div v-if="security_code_by_text && security_code_by_email" class="row">
      <div class="col-md-12 m-5">
        <fieldset><br>
          <div class="form-group">
            <h5 class="text-center">
              {{ translatedFields['how_would_you_like_to_receive_your_security_code'] }}?
            </h5>
            <br>
            <div class="col-sm-6 mt-15 p-0 text-center">
              <div class="row">
                <div class="col-md-12">
                  <i v-bind:class=" model.sendMethod === 'email' ? 'active' : '' " class="fa fa-at fa-3x"></i>
                </div>
                <div class="col-md-12 m-5">
                  <p-radio v-model="model.sendMethod"
                          name = "sendMethod"
                          v-validate="modelValidations.sendMethod"
                          @input="switchEmailPhone('email')" 
                          inline label="email"> {{ this.$store.state.results.user.email }}
                  </p-radio>
                </div>
              </div>
            </div>
            <div class="col-sm-6 mt-15 text-center">
              <div class="row">
                <div class="col-md-12">
                  <i v-bind:class=" model.sendMethod === 'phone' ? 'active' : '' " class="fa fa-phone fa-3x"></i>
                </div>
                <div class="col-md-12 m-5">
                  <p-radio v-model="model.sendMethod"
                          @input="switchEmailPhone('phone')" 
                          inline label="phone">{{ this.$store.state.results.user.phone }}
                  </p-radio>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <div class="col-md-12 text-center">
          <small class="text-danger" v-show="sendMethod.invalid">
            {{ getError('sendMethod') }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {mapFields} from 'vee-validate'

export default {
  data () {
    return {
      security_code_by_text: process.env.SECURITY_CODE_BY_TEXT,
      security_code_by_email: process.env.SECURITY_CODE_BY_EMAIL,
      phone: false,
      translatedFields: '',
      fields_en: {
        how_would_you_like_to_receive_your_security_code: 'How would you like to receive your security code'
      },
      model: {
        sendMethod: ''
      },
      modelValidations: {
        sendMethod: {
          required: true
        }
      }
    }
  },
  methods: {
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    async validate () {
      if (this.model.sendMethod === 'email') {
        this.$store.state.results.user['sendTo'] = this.$store.state.results.user.email
      } else {
        this.$store.state.results.user['sendTo'] = this.$store.state.results.user.phone
      }
      if (!this.model.sendMethod) {
        this.$validator.errors.add({field: 'sendMethod', msg: 'Please choose one!'})
        let field = this.$validator._resolveField('sendMethod')
        field.setFlags({invalid: true})
        return false
      } else {
        if (process.env.SECURITY_CODE_BY_TEXT && process.env.SECURITY_CODE_BY_EMAIL) {
          let form = {
            code: this.$store.state.results.user.code,
            send_method: this.model.sendMethod
          }
          await axios.post(process.env.SERVER_URI + '/generate/confirmation_code', form).then((response) => {
            if (response.data === false) {
              this.$validator.errors.add({field: 'sendMethod', msg: 'Server issues!'})
              let field = this.$validator._resolveField('sendMethod')
              field.setFlags({invalid: true})
              //eslint-disable-next-line
              reject(new Error('Server issues!'))
            }
          }).catch(() => {
            this.$validator.errors.add({field: 'sendMethod', msg: 'Server issues!'})
            let field = this.$validator._resolveField('sendMethod')
            field.setFlags({invalid: true})
            //eslint-disable-next-line
            reject(new Error('Server issues!'))
          })
        }
        return this.$validator.validateAll()
      }
    },
    checkLanguage () {
      if (this.$store.state.lang.value === 'ES') {
        this.translatedFields = this.$store.state.translation_es
      } else {
        if (this.$store.state.lang.value === 'ZH') {
          this.translatedFields = this.$store.state.translation_zh
        } else {
          this.translatedFields = this.fields_en
        }
      }
    },
    switchEmailPhone (data) {
      if (data === 'email') {
        this.model.sendMethod = 'email'
      } else {
        this.model.sendMethod = 'phone'
      }
    }
  },
  computed: {
    language () {
      this.checkLanguage()
      return this.$store.state.lang.value
    },
    spanishFields () {
      return this.$store.state.translation_es
    },
    chineseFields () {
      return this.$store.state.translation_zh
    },
    ...mapFields(['sendMethod'])
  },
  watch: {
    language () {
      this.checkLanguage()
    }
  }
}
</script>

<style scoped>
  .m-5{
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .active{
    color: #f4c617;
    transition:color 0.2s ease-in;
  }

  .text-center{
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Results/Wizard/ChooseMethod.vue